import { IS_NEW_BACKEND_API } from '@skytech/utils'

import { get } from '@/util/auth'

import type { WorkflowExecution } from './activities'

export type WorkflowNotification = WorkflowExecution & {
  notificationType: 'workflow'
  date: string
}

type OpenEndOfLeaseDecision = {
  assetId: number
  endOfLeaseDate: Date
  processStartDate: Date
  employeeDecisionOpenDate: Date
  employeeDecisionDeadlineDate: Date
  assetReturnCutoffDate: Date | null
  currentEndingOption: string
  processStartedDatetime: Date
  completedDatetime: Date
  cancelledDatetime: Date
  startDate: Date
  ecomOrderId: number
  policyId: number
}
type OpenEndOfLeaseDecisionNotification = OpenEndOfLeaseDecision & {
  notificationType: 'end_of_lease_decision_deadline'
  date: string
}

export type BuyoutOfferNotification = {
  notificationType: 'buyout_offer'
  date: string
  id: number
  assetId: number
  assetDescription: string
  price: number
  offerExpirationDate: string
  createdDate: string
}

export type Notification =
  | WorkflowNotification
  | BuyoutOfferNotification
  | OpenEndOfLeaseDecisionNotification

export const notificationResources = {
  list: async (): Promise<Notification[]> =>
    get<Notification[]>('notifications', IS_NEW_BACKEND_API),
}
